import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./JoinGame.css";
import CookieConsent from "./cookies";

const API_URL = process.env.REACT_APP_API_URL;

const JoinGame = () => {
  const [players, setPlayers] = useState([]);
  const [selectedPlayer, setSelectedPlayer] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalButton, setModalButton] = useState("");
  const [modalAction, setModalAction] = useState(() => {});
  const [passwordValue, setPasswordValue] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalError, setModalError] = useState(""); // ← red error text

  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_URL}/players`)
      .then((res) => res.json())
      .then((data) => setPlayers(data))
      .catch((err) => console.error("Error fetching players:", err));
  }, []);

  const openPasswordModal = ({ title, buttonLabel, action }) => {
    setModalTitle(title);
    setModalButton(buttonLabel);
    setModalAction(() => action);
    setPasswordValue("");
    setShowPassword(false);
    setModalError("");
    setModalOpen(true);
  };

  const handleModalSubmit = async () => {
    if (!passwordValue) {
      setModalError("Password cannot be empty");
      return;
    }
    setLoading(true);
    await modalAction(passwordValue);
    setLoading(false);
  };

  const handleJoin = async () => {
    if (!selectedPlayer) {
      return openPasswordModal({
        title: "Please select a player",
        buttonLabel: "OK",
        action: () => setModalOpen(false),
      });
    }

    try {
      const claimedRes = await fetch(
        `${API_URL}/players/${selectedPlayer}/claimed`
      );
      const claimedData = await claimedRes.json();

      if (claimedData.claimed) {
        openPasswordModal({
          title: "Player is claimed. Enter your password",
          buttonLabel: "Login",
          action: async (password) => {
            const loginRes = await fetch(
              `${API_URL}/players/${selectedPlayer}/login`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ password }),
              }
            );

            if (!loginRes.ok) {
              setModalError("Incorrect password"); // ← inline red text
              return;
            }

            setModalOpen(false);
            navigate(`/game/${selectedPlayer}`);
          },
        });
      } else {
        openPasswordModal({
          title: "Player is unclaimed. Create a password",
          buttonLabel: "Claim Player",
          action: async (password) => {
            const claimRes = await fetch(
              `${API_URL}/players/${selectedPlayer}/claim`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ password }),
              }
            );

            const data = await claimRes.json();
            if (!claimRes.ok) {
              setModalError(data.error || "Error claiming player"); // ← inline red text
              return;
            }

            setModalOpen(false);
            navigate(`/onboard/${selectedPlayer}`);
          },
        });
      }
    } catch (err) {
      console.error("Error joining game:", err);
      setModalError("Something went wrong");
    }
  };

  return (
    <div>
      {/* Cookie consent banner */}
      <CookieConsent />

      <div className="join-game-container">
        <h1 className="join-game-title">Join 'Secret Sex Cum'</h1>
        <p className="join-game-subtitle">Select your name from the list!</p>

        <select
          value={selectedPlayer}
          onChange={(e) => setSelectedPlayer(e.target.value)}
          className="join-game-select"
        >
          <option value="">Select your name</option>
          {players.map((player) => (
            <option key={player.id} value={player.id}>
              {player.name}
            </option>
          ))}
        </select>

        <button className="join-game-button" onClick={handleJoin}>
          Continue
        </button>

        {/* Modal */}
        {modalOpen && (
          <div className="modal-backdrop">
            <div className="modal-box">
              <h2>{modalTitle}</h2>

              {modalTitle.toLowerCase().includes("password") && (
                <div className="modal-input-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter password"
                    value={passwordValue}
                    onChange={(e) => setPasswordValue(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleModalSubmit()}
                  />
                  <button
                    className="show-hide-btn"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    {showPassword ? "Hide" : "Show"}
                  </button>
                </div>
              )}

              {modalError && <div className="modal-error">{modalError}</div>}

              <button
                className="modal-submit-btn"
                onClick={handleModalSubmit}
                disabled={loading}
              >
                {loading ? "..." : modalButton}
              </button>

              <button
                className="modal-cancel-btn"
                onClick={() => setModalOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default JoinGame;
